import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSettings } from '../services/api';
import { businessInfo as fallbackBusinessInfo } from '../data/mock';

const SettingsContext = createContext(null);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

// Transform API response to match the existing businessInfo structure
const transformSettings = (settings) => {
  if (!settings) return null;
  
  return {
    name: settings.name || '',
    tagline: settings.tagline || '',
    description: settings.description || '',
    location: settings.location || '',
    address: settings.address || '',
    phone: settings.phone || '',
    email: settings.email || '',
    whatsapp: settings.whatsapp || '',
    instagram: settings.instagram || '',
    instagramUrl: settings.instagram_url || '',
    hours: {
      weekdays: settings.hours_weekdays || '',
      saturday: settings.hours_saturday || '',
      sunday: settings.hours_sunday || ''
    }
  };
};

export const SettingsProvider = ({ children }) => {
  const [businessInfo, setBusinessInfo] = useState(fallbackBusinessInfo);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = async () => {
    try {
      const settings = await getSettings();
      const transformed = transformSettings(settings);
      if (transformed) {
        setBusinessInfo(transformed);
      }
      setError(null);
    } catch (err) {
      console.error('Failed to fetch settings:', err);
      setError(err);
      // Keep using fallback data
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ businessInfo, loading, error, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
